// ValouBadge - Einzelner farbiger Badge fuer einen Valou-Bereich

import React from 'react';
import type { ValouAreaId } from '../../types/valou';
import { getValouAreaConfig } from '../../types/valou';

interface ValouBadgeProps {
  areaId: ValouAreaId;
  size?: 'xs' | 'sm' | 'md';
  showLabel?: boolean;
  variant?: 'filled' | 'outline';
  className?: string;
}

export function ValouBadge({
  areaId,
  size = 'sm',
  showLabel = true,
  variant = 'filled',
  className = '',
}: ValouBadgeProps) {
  const config = getValouAreaConfig(areaId);

  if (!config) {
    return null;
  }

  const sizeClasses = {
    xs: 'text-xs px-1.5 py-0.5 gap-0.5',
    sm: 'text-xs px-2 py-1 gap-1',
    md: 'text-sm px-3 py-1.5 gap-1.5',
  };

  const iconSizes = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
  };

  const baseClasses = `
    inline-flex items-center rounded-full font-medium transition-colors
    ${sizeClasses[size]}
    ${className}
  `;

  const variantStyles =
    variant === 'filled'
      ? {
          backgroundColor: `${config.color}20`, // 20% opacity
          color: config.color,
          border: `1px solid ${config.color}40`,
        }
      : {
          backgroundColor: 'transparent',
          color: config.color,
          border: `1.5px solid ${config.color}`,
        };

  return (
    <span className={baseClasses} style={variantStyles} title={config.description}>
      <span className={iconSizes[size]}>{config.icon}</span>
      {showLabel && <span>{config.shortName}</span>}
    </span>
  );
}

export default ValouBadge;
